import { Feature, Point, Polygon } from "geojson";
import { GeoService } from "../services/internal-services/geo.service";

export class MapStatus {
  extent: Feature<Polygon>;

  center: Feature<Point>;

  zoom: number;

  _swipeStatus: any = {
    enable: false,
    getAOIAtPoint: null,
    left: null,
    right: null,
  };

  _is3dMode: boolean;

  _orientation: string;

  _geotiffStatus: boolean = false;

  constructor(
    center?: Feature<Point>,
    extent?: Feature<Polygon>,
    zoom?: number,
    swipeStatus?: any,
    is3dMode?: boolean,
    orientation?: string,
    geotiffStatus?: boolean,
  ) {
    this.extent = extent;
    this.center = center;
    this.zoom = zoom;
    this._swipeStatus = swipeStatus;
    this._is3dMode = is3dMode;
    this._orientation = orientation;
    this._geotiffStatus = geotiffStatus;
  }

  set swipeStatus(swipeStatus: any) {
    this._swipeStatus = swipeStatus;
  }

  get swipeStatus(): any {
    return this._swipeStatus;
  }

  set geotiffStatus(geotiffStatus: boolean) {
    this._geotiffStatus = geotiffStatus;
  }

  get geotiffStatus(): any {
    return this._geotiffStatus;
  }

  get is3dMode(): boolean {
    return this._is3dMode;
  }

  set is3dMode(is3dMode: boolean) {
    this._is3dMode = is3dMode;
  }

  get orientation(): string {
    return this._orientation;
  }

  set orientation(orientation: string) {
    this._orientation = orientation;
  }

  /**
   * Compare two map status to avoid relaunch events
   * @param {MapStatus} status
   * @returns {boolean} false if status is empty or if its different
   */
  compare(status: MapStatus): boolean {
    if (!status) {
      return false;
    }
    return (
      status.zoom === this.zoom &&
      GeoService.isCenterEquals(this.center.geometry.coordinates, status.center.geometry.coordinates)
    );
  }
}
